import styled, { css } from 'styled-components';
import { Swiper } from 'swiper/react';

import { Box } from '@/components/Box';
import type { ProductTypeOptions } from '@/lib/product';

import zoomCursor from '@/assets/cursor-zoom.png';

export const Wrapper = styled(Box)`
  position: relative;
  height: 100%;
  ${({ theme }) => css`
    ${theme.media.md.down} {
      height: 100vw;
    }
  `}
`;

export const StyledSwiper = styled(Swiper)<{ type: ProductTypeOptions }>`
  ${({ theme }) => css`
    .swiper-scrollbar {
      bottom: 0;
    }
    .swiper-scrollbar-drag {
      background: ${theme.colors.primary};
    }
    ${theme.media.md.down} {
      .next-image {
        height: 100vw;
      }
    }
  `}

  &.swiper {
    height: 100vw;
    ${({ theme }) => css`
      @media (min-width: ${theme.breakpoints.md}) {
        max-height: 645px;
      }

      @media (min-width: 1200px) {
        max-height: 695px;
      }
    `}

    &-slide {
      text-align: center;
      overflow: hidden;
      height: auto;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &-scrollbar {
      background: #07213f;
      height: 2px;
      bottom: 0;
      width: 100%;

      &-drag {
        background: ${({ theme }) => theme.colors.primary};
      }
    }
  }
`;

export const Navigation = styled.span<{ type: 'next' | 'prev' }>`
  position: absolute;
  z-index: 1;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: all;

  ${({ theme, type }) => css`
    padding: ${theme.spacing(2)};
    ${type === 'next' ? 'right' : 'left'}: -10px;
  `}

  :hover {
    cursor: pointer;
  }

  svg {
    height: 38px;

    path {
      fill: ${({ theme }) => theme.colors.black};
    }
  }

  &.swiper-button {
    &-disabled {
      svg path {
        fill: ${({ theme }) => theme.colors.defaultAdd4};
      }

      &:hover {
        cursor: not-allowed;
      }
    }
  }
`;

export const PhotoSwipeLink = styled.a<{ isProcessing: boolean }>`
  ${({ isProcessing }) =>
    css`
      cursor: ${isProcessing
        ? 'wait'
        : `url(${zoomCursor.src}) 25 25, zoom-in`};
    `}
`;
